import "./App.css";
import Mainprofile from "./component/Mainprofile";
import About from "./component/pages/about/about";
import Home from "./component/pages/home/Home";
import Navbar from "./component/Right-side/Navbar";
import Resume from "./component/pages/resume/resume";
import Skills from "./component/pages/skills/skills";
import Portfolio from "./component/pages/portfolio/portfolio";
import Contacts from "./component/pages/contact/Contacts";
import Lenis from "@studio-freight/lenis";
import { useEffect } from "react";
function App() {

  useEffect(() => {
    const lenis = new Lenis();

    lenis.on("scroll", (e) => {
      console.log(e);
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  },[])


  return (
    <div className="App">
      <div className="main-page">

        <div
          className="left-page"
        >
          <Mainprofile />
        </div>
        <div id="containerdiv" className="right-page">
          <div className="right-page-inner-content">
          <div id="home" className="first-slide">
            <Home />
          </div>
          <div id="about" className="second-slide">
            <About />
          </div>
          <div id="resume" className="third-slide">
            <Resume />
          </div>
          <div id="skill" className="fourth-slide">
            <Skills />
          </div>
          <div id="projects" className="fifth-slide">
            <Portfolio />
          </div>
            <div id="contact" className="sixth-slide">
              <Contacts/>
            </div>
          </div>
        </div>
        <div
          className="navbar-page"
        >
          <Navbar />
          
        </div>
      </div>
    </div>
  );
}

export default App;
